<form (ngSubmit)="onSubmit()" [formGroup]="modelPjFileForm" style="margin-top: 20px">
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="15px">
      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <mat-label>Catégorie du modèle</mat-label>
        <mat-select formControlName="template_type">
          <mat-option *ngFor="let type of data.modelTypes" [value]="type.id">{{type.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <mat-label>Nom du modèle</mat-label>
        <input formControlName="template_name" matInput
               matTooltip="Nom du modèle de pièce jointe"
               placeholder='Nom du modèle de pièce jointe'>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="onNoClick()"
            mat-raised-button
            color="primary"
            type="button">
      Annuler
    </button>
    <button mat-raised-button
            cdkFocusInitial
            color="accent"
            type="submit"
            [disabled]="!modelPjFileForm.valid">
      Sauvegarder
    </button>
  </mat-dialog-actions>
</form>
